import { ApiConfigs } from '@/configs/apis';
import { Service } from '@/services/di-provider';
import HttpService from '@/services/http-service';
// Models
import axios from 'axios';
import type { UserModel } from '@/models/user';

@Service
export default class UserService {
  httpService!: HttpService;

  constructor() {
    this.httpService = new HttpService();
  }

  async userInfo(): Promise<UserModel> {
    const { baseUrls } = ApiConfigs;

    try {
      const { data } = await this.httpService.httpInstance.get<UserModel>(baseUrls.userInfo);

      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data as any;
      }

      return {} as UserModel;
    }
  }
}
